export default __webpack_public_path__ + "static/media/Architecture_and_Interior.12f0d803.jpg";